export enum EnumPage {
    UserManage = 'UserManage',
    UserGroupManage = 'UserGroupManage',
    PageManage = 'PageManage',
    MenuManage = 'MenuManage',
    CarManage = 'CarManage',
    CarQueueManage = 'CarQueueManage',
    Closed = 'Closed',
    StoreManage = 'StoreManage',
}

export type EnumPageValue = `${EnumPage}`;

export const EnumPageMap: {
    [key in EnumPage]: { key: EnumPage; descr: string };
} = {
    [EnumPage.UserManage]: { key: EnumPage.UserManage, descr: '使用者管理' },
    [EnumPage.UserGroupManage]: { key: EnumPage.UserGroupManage, descr: '使用者群組管理' },
    [EnumPage.PageManage]: { key: EnumPage.PageManage, descr: '頁面管理' },
    [EnumPage.MenuManage]: { key: EnumPage.MenuManage, descr: '選單管理' },
    [EnumPage.CarManage]: { key: EnumPage.CarManage, descr: '車輛管理' },
    [EnumPage.CarQueueManage]: { key: EnumPage.CarQueueManage, descr: '排序管理' },
    [EnumPage.Closed]: { key: EnumPage.Closed, descr: '店休管理' },
    [EnumPage.StoreManage]: { key: EnumPage.StoreManage, descr: '店面管理' },
};
